import { Box, Flex, Heading, Image, Text } from "@chakra-ui/react"
import { useContext, useEffect } from "react"
import Aos from "aos"
import "aos/dist/aos.css"
import styled from "styled-components"
import { ColorContext } from "../Context/ColorContext"
import bharat2 from "../Images/imageedit_15_3689960756.png"
function About() {


    useEffect(() => {
        Aos.init({ duration: 1000 })
    }, [])



    const { colors, setColors, underLineColor, textColor, family } = useContext(ColorContext)

    // const family = 'system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;'

    return (
        <Box id="about" className="about section" bgColor={colors} fontFamily={family}>
            <Box bgColor={colors} mt={"20%"} textAlign={"center"} padding={"2px 0px"} color={"white"}>
                <Heading p={'1% 1%'} color='white' fontSize={['1.5rem','1.9rem','2.6rem','3.2rem']} textAlign={"center"} mt={"1%"} id="about" className="about section">About Us</Heading>

                <Flex flexDirection={['column','column','column','row']} alignItems={['center']} justifyContent={'space-around'} p={['5% 1%','5% 1%','5% 1%','5% 8%']} data-aos="fade-right">
                    <Text textAlign={'left'} mb={['4%','4%','4%','0%']} p={['4% 2%','4% 2%','4% 2%','4%']} bgColor={'white'} fontWeight={'500'} borderRadius={'10px'} fontSize={['0.9rem','1rem','1.1rem','1.2rem']} w={['100%','80%','80%','50%']}  id="user-detail-intro" color={'black'}> I am Full Stack Developer with a passion for building beautiful and user-friendly websites. I have great understanding of both front-end and back-end also have done some projects using HTML,CSS,JavaScript and React, and I am exicited for put my skills to use in a professional. I like travelling and learning new things, and I am confident that I can be a valuable asset for your organization. </Text>
                    <Image src={bharat2} alt="" bgColor={'white'} w={['45%','40%','30%','25%']}  borderRadius={'50%'} />

                </Flex>

            </Box>
        </Box>
    )

}

export default About
